import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-bs-parent"]
const _hoisted_2 = { class: "p-3" }


import TemperatureScale from '@/components/charts/alarmCharts/TemperatureScale.vue'
import { TEMPERATURE_CONFIG } from '@/constants/temperatureConstants'


export default /*@__PURE__*/_defineComponent({
  __name: 'DTS',
  props: {
  accordionInnerId: {
    type: String,
    required: true
  },
  accordionOuterId: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.accordionInnerId,
    class: "accordion-collapse collapse accordion-border",
    "data-bs-parent": '#' + __props.accordionOuterId
  }, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-typography NKT-P2 mb-0" }, "Conductor temperature", -1)),
      _createVNode(TemperatureScale, { config: _unref(TEMPERATURE_CONFIG) }, null, 8, ["config"])
    ])
  ], 8, _hoisted_1))
}
}

})